

<template>
  <br>
  <p class="fw-bold">   </p>

  <div class="d-flex  mb-2 w-100 justify-content-evenly">
    <div class="  d-flex flex-column">
      <label class="text-end">کد</label>
      <input v-model="code" type="text" class="form-control">
    </div>

    <div class="  d-flex flex-column">
      <label class="text-end">عنوان اثر</label>
      <input type="text" class="form-control" v-model="title">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">ماهیت اثر      </label>
      <input type="text" class="form-control" v-model="nature">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">مالک اثر </label>
      <input type="text" class="form-control" v-model="owner" placeholder="انتخاب کنید" readonly @click.prevent="showListOrganization">
    </div>

    <div class="  d-flex flex-column">
      <label class="text-end">پیامد میانی   </label>
      <input type="text" class="form-control" v-model="outputName" placeholder="انتخاب کنید" readonly @click.prevent="showListOutput">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">نماگر پایش اثر    </label>
      <input type="text" class="form-control" v-model="measurement_chart">
    </div>
    <div class="  d-flex flex-column">
      <label class="text-end">واحد سنجش  نماگر اثر    </label>
      <input type="text" class="form-control" v-model="unit">
    </div>

    <button v-if="!is_update" @click.prevent="submitForm" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ثبت</button>
    <button v-else @click.prevent="update(id)" style="margin-top: 1.3vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
  </div>
  <center>
    <hr style="width: 70vw; margin: 1vw 0;">
    <p v-show="!items.length">
      تعریف اثر   یافت نشد
    </p>
    <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

    <table v-show="items.length" class="table table-striped" style="width: 70vw;" >
      <thead>
      <tr>
        <th style="width: 1vw;"> ردیف</th>
        <th>کد  </th>
        <th>عنوان  </th>
        <th>ماهیت  </th>
        <th>مالک    </th>
        <th>پیامد میانی     </th>
        <th>نماگر پایش اثر      </th>
        <th>ماهیت اثر        </th>
        <th style="width: 8vw;">عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr  v-for="(item, index) in items">
        <td scope="row" style=" font-size: 1vw">{{index+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.title}}</td>
        <td>{{item.nature}}</td>
        <td>{{item.organizationpost.name}}</td>
        <td>{{item.intermediate_outcome.title}}</td>

        <td>{{item.measurement_chart}}</td>
        <td>{{item.unit}}</td>





        <td>
          <a @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
          <a @click.prevent="deleteItemModal(item.id) " href="#"><img class="table-delete-img mx-2"  src="/img/delete.f9fc94bc.svg" alt="delete"></a>
        </td>
      </tr>

      </tbody>
    </table>
      </div>
  </center>
  <div dir="rtl" class="modal__error slide-top" v-show="select_organization"
       style="z-index: 999999999999999999999999999999999999999999999; top: 4%;">
    <div>
      <p>مالک اثر      </p>
      <p @click="select_organization=!select_organization">❌</p>
    </div>
    <div>
      <input style="width: 20vw;" v-model="search_organization" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>پست سازمانی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td style="width: 1vw;" scope="row"><input v-model="organizationId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_organizationMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="select_output"
       style="z-index: 999999999999999999999999999999999999999999999; top: 4%;">
    <div>
      <p> پیامد میانی    </p>
      <p @click="select_output=!select_output">❌</p>
    </div>
    <div>
      <input style="width: 20vw;" v-model="search_output" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد و عنوان  ...">
      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>کد</th>
          <th>عنوان      </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredOutputs" :key="item.id">
          <td style="width: 1vw;" scope="row"><input v-model="outputId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['code'] }}</td>
          <td>{{ item['title'] }}</td>
        </tr>

        </tbody>
      </table>
      <button @click="select_outputMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->

</template>
<script  >
export  default {
  data(){
    return{
      all_outputs: [],
      all_organization: [],
      items: [],
      code: '',
      title: '',
      owner: '',
      nature: '',
      received: '',
      MeasurementChart: '',
      GraphMeasuringUnit: '',
      id: '',
      outputId: '',
      outputName: '',
      organizationId: '',
      search_organization: '',
      measurement_chart: '',
      unit: '',
      search_output: '',
      select_organization: false,
      select_output: false,
      is_update: false,
      deleteModal: false,

    }
  },
  methods:{
    deleteItemModal(id){
      this.id=id
      this.deleteModal=true

    },
    edit(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/show/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = response.item.code
              this.title = response.item.title
              this.nature = response.item.nature
              this.measurement_chart = response.item.measurement_chart
              this.unit = response.item.unit
              this.owner = response.item.organizationpost.name
              this.organizationId = response.item.organizationpost.id
              this.outputId = response.item.intermediate_outcome.id
              this.outputName = response.item.intermediate_outcome.title
              this.is_update=true
              this.id = response.item.id
            }



          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('owner_id', this.organizationId)
      formdata.append('intermediate_outcomes_id', this.outputId)
      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('nature', this.nature)
      formdata.append('measurement_chart', this.measurement_chart)
      formdata.append('unit', this.unit)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = ''
              this.title = ''
              this.owner = ''
              this.organizationId = ''
              this.outputId = ''
              this.outputName = ''
              this.measurement_chart = ''
              this.unit = ''
              this.id = ''
              this.nature = ''

              this.allItems()
              this.is_update=false
              this.id=''
            }



          })
          .catch();
    },
    deleteItemForm(id){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){

              this.deleteModal=false
              this.id=''
              this.allItems()
            }



          })
          .catch();
    },
    submitForm(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('owner_id', this.organizationId)
      formdata.append('intermediate_outcomes_id', this.outputId)
      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('nature', this.nature)
      formdata.append('measurement_chart', this.measurement_chart)
      formdata.append('unit', this.unit)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response){
              this.code = ''
              this.title = ''
              this.owner = ''
              this.organizationId = ''
              this.outputId = ''
              this.outputName = ''
              this.unit = ''
              this.nature = ''
              this.measurement_chart = ''

              this.allItems()
            }



          })
          .catch();
    },
    allItems(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){
              this.items.length=0
              response.items.forEach((item)=>{
                this.items.push(item)
              })
            }



          })
          .catch();
    },
    select_organizationMethod() {
      this.all_organization.forEach((ele) => {
        ele.id === this.organizationId ? this.owner = ele.name : ''
      })
      this.select_organization = false


    },
    showListOrganization() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_organization.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_organization.push(item)

              })
              this.select_organization = true

            }

          })
          .catch();
    },
    select_outputMethod() {
      this.all_outputs.forEach((ele) => {
        ele.id === this.outputId ? this.outputName = ele.title : ''
      })
      this.select_output = false


    },
    showListOutput() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/intermediate_outcome/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_outputs.length = 0

            if (result['items'].length !== 0) {
              result['items'].forEach(item => {
                this.all_outputs.push(item)

              })
              this.select_output = true

            }

          })
          .catch();
    },


  },
  computed:{
    filteredorganization() {
      return this.all_organization.filter(item => {
        return (
            item['name'].includes(this.search_organization) ||
            item['id'].toString().includes(this.search_organization)
        );
      });
    },
    filteredOutputs() {
      return this.all_outputs.filter(item => {
        return (
            item['title'].includes(this.search_output) ||
            item['code'].toString().includes(this.search_output)
        );
      });
    },
  },
  mounted() {
    this.allItems()
  }
}

</script>
<style scoped>
label{
  font-size: .8vw;
}
input{
  width: 8vw;
}
</style>